import React, { useState } from "react";
import { Button, Form, TextArea, Segment, Header } from "semantic-ui-react";
import {toast} from "../../../common/Toast";
import LocalStorage from "../../../../lib/LocalStorage";
import config from "../../../../common/repository/config";

const AddTest: React.FC = () => {
  const [prompt, setPrompt] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [items, setItems] = useState<string>("");
  const handleSubmit = async () => {
    const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
    if (!token) {
      toast.error("Authentication token is missing.");
      return;
    }
    try {
      setLoading(true);

      const response = await fetch(`${config.apiBaseURL}/case/testVertex`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify({ prompt }),
      });
      const data = await response.json();
      if (response.ok) {
        // toast.success("API call successful!");
        setItems(data?.data?.items || "No items found.");
      } else {
        toast.error(data.message || "Something went wrong.");
      }
    } catch (error) {
      toast.error("Failed to connect to server.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 600, margin: "2rem auto" }}>
      <Form onSubmit={handleSubmit} loading={loading}>
        <Form.Field>
          <label style={{ fontWeight: "bold", fontSize: "1.1rem" }}> Test Prompt Here</label>
          <TextArea
            placeholder="Enter your prompt..."
            value={prompt}
            onChange={(e) => setPrompt(e.currentTarget.value)}
            style={{ minHeight: 120 }}
          />
        </Form.Field>
        <Button
          primary
          type="submit"
          loading={loading}
          disabled={!prompt}
          style={{ marginTop: "1rem" }}
        >
          Submit
        </Button>
      </Form>

      {/* Show only items field */}
      {items && (
        <Segment
          raised
          style={{
            marginTop: "2rem",
            padding: "1.5rem",
            background: "#f9f9f9",
            borderRadius: "12px",
            whiteSpace: "pre-wrap",
          }}
        >
          <Header as="h3" style={{ marginBottom: "1rem" }}>
            Response Items
          </Header>
          {items}
        </Segment>
      )}
    </div>
  );
};

export default AddTest;
